import "./Contact.scss";
import slide4 from 'Website/assets/images/slide4.png';
import { useTranslation } from "react-i18next";
const Contact = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className="banner_section right">
                <div>
                    <div className="banner_image_content">
                        <div>
                            <h1 className="title">{t('pages.contactUs.title')}</h1>
                            <p>{t('pages.contactUs.desc')}</p>
                            <div className='contact_box'>
                                <div>
                                    <h5>{t('genericContent.email')}</h5>
                                    {/* <span>{process.env.REACT_APP_CONTACT_MAILID}</span> */}
                                    <span>developer@nibavlifts.com</span>
                                    {/* <span>info@daz.im</span> */}
                                </div>
                                <div>
                                    <h5>{t('genericContent.phoneNumber')}</h5>
                                    {/* <span>{process.env.REACT_APP_CONTACT_NUMBER}</span> */}
                                    <span>(+44) 7534457157</span>
                                </div>
                                {/* <div>
                                    <h5>{t('genericContent.mailingAddress')}</h5>
                                    <span>DAZ LLC 1234</span>
                                    <span>Jakarta -Indonesia</span>
                                </div> */}
                            </div>
                            <div className='contact_box address-sec'>
                                <div>
                                    <h5>Support Hours</h5>
                                    <span>Mon–Fri | 9 AM – 6 PM IST</span>
                                    {/* <span>7 Bell Yard, London, England, WC2A 2JR</span> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <picture>
                        <img src={slide4} alt='Contact Us' title='Contact Us' className="lazy-img" />
                    </picture>
                </div>
            </section>
        </>
    )
}

export default Contact;